module.exports = __webpack_public_path__ + "static/img/tbg1.0a04a7db.png";